// extracted by mini-css-extract-plugin
export default {"container":"NotPermittedRoute__container--EWD3YP5gMZINifrirKOg"};